// ANT Modules
import { DatePicker, Space } from "antd";

// Hooks
import { useDateTimePicker } from "components/atoms/DateTimePicker/useDateTimePicker";

// Modules
import moment from "moment";

// Utils
import getIcon from "utils/getIcon";
import { DateTimeFormats } from "constants/global";

export type DateTimePickerProps = {
	classes?: string;
	placeholder?: string;
	defaultDate?: string;
	onDateChange?: (date: any, dateString: string) => void;
	onDateOk?: (value: moment.Moment) => void;
	disabled?: boolean;
};

const DateTimePicker = ({ classes, placeholder, defaultDate, disabled, onDateChange, onDateOk }: DateTimePickerProps): JSX.Element => {
	const { disabledDate } = useDateTimePicker();
	return (
		<Space direction="vertical" size={12}>
			<DatePicker
				defaultValue={defaultDate?.length ? moment(defaultDate) : undefined}
				allowClear={false}
				className={`${classes}`}
				placeholder={placeholder}
				showTime={{ use12Hours: true, format: "hh:mm" }}
				onChange={onDateChange}
				onOk={onDateOk}
				disabledDate={disabledDate}
				suffixIcon={getIcon({ icon: "calender" })}
				disabled={disabled}
				format={DateTimeFormats.USE_AM_PM}
			/>
		</Space>
	);
};

export default DateTimePicker;
